import { Button } from "@mui/material";
import React, { useState } from "react";
import LaunchIcon from "@mui/icons-material/Launch";
import ApprovalDrawer from "./ApprovalDrawer";

const PreviewBtn = ({ title = "Preview Approval Stages", data, allData }) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const toggleDrawer = (open) => {
    setOpenDrawer(open);
  };
  return (
    <>
      <Button
        sx={{
          fontSize: "12px",
          textTransform: "none",
          // marginLeft: "20px",
        }}
        variant="outlined"
        onClick={() => toggleDrawer(true)}
      >
        {title}
        <LaunchIcon
          sx={{
            width: "14px",
            marginLeft: "10px",
          }}
          className="h-2 w-2 cursor-pointer"
        />
      </Button>
      <ApprovalDrawer
        allData={allData}
        open={openDrawer}
        toggleDrawer={toggleDrawer}
        approvalItems={data}
      />
    </>
  );
};

export default PreviewBtn;
